import { fetchUtils } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';

import { API_HOST } from './env';
import { localToken } from './authProvider';

const httpClient = (url, options = {}) => {
  if (!options.headers) {
      options.headers = new Headers({ Accept: 'application/json' });
  }
  const token = localToken();
  options.headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(url, options);
};
const dataProvider = jsonServerProvider(API_HOST + '/api/supervisors', httpClient);

// Extending a Data Provider (Example of File Upload)
// https://marmelab.com/react-admin/DataProviders.html#decorating-your-data-provider-example-of-file-upload
const customDataProvider = {
  ...dataProvider,
  create: (resource, params) => {
    if (resource !== 'student_files') {
        // fallback to the default implementation
        return dataProvider.create(resource, params);
    }
    /**
     * For posts update only, convert uploaded image in base 64 and attach it to
     * the `file` sent property, with `src` and `title` attributes.
     */

    // Freshly dropped files are File objects and must be converted to base64 strings
    const p = params.data.file.rawFile instanceof File ?
      convertFileToBase64(params.data.file)
      : Promise.resolve(params.data.file);
    return p.then(file =>
            dataProvider.create(resource, {
                ...params,
                data: {
                    ...params.data,
                    file: file
                },
            })
        );
  },
};

/**
* Convert a `File` object returned by the upload input into a base 64 string.
* That's not the most optimized way to store images in production, but it's
* enough to illustrate the idea of data provider decoration.
*/
const convertFileToBase64 = file =>
  new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.rawFile);

      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
  }).then(file64 => ({
    src: file64,
    title: `${file.title}`,
  }));

export default customDataProvider;
